'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import HomeTopBar from './home-screen/components/HomeTopBar';
import ModuleGrid from './home-screen/components/ModuleGrid';
import WalletPeekCard from './home-screen/components/WalletPeekCard';
import FeaturedListings from './home-screen/components/FeaturedListings';
import RecentClassifieds from './home-screen/components/RecentClassifieds';
import ActivityFeed from './home-screen/components/ActivityFeed';
import Recommendations from './home-screen/components/Recommendations';

export default function HomePage() {
  return (
    <AppLayout>
      <div className="min-h-screen" style={{ background: 'var(--background)' }}>
        <div className="px-4 pb-24">
          <HomeTopBar />
          <div className="mt-4 space-y-5">
            <WalletPeekCard />
            <Recommendations />
            <ModuleGrid />
            <FeaturedListings />
            <RecentClassifieds />
            <ActivityFeed />
          </div>
        </div>
      </div>
    </AppLayout>
  );
}